import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { PageNotFoundComponent } from './components/common/page-not-found/page-not-found.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/user/login/login.component';
import { RegisterComponent } from './components/user/register/register.component';
import { ForgotPasswordComponent } from './components/user/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/user/reset-password/reset-password.component';
import { CourseListComponent } from './components/course/course-list/course-list.component';
import { CoursesListComponent } from './components/course/courses-list/courses-list.component';
import { PageLayoutComponent } from './components/common/page-layout/page-layout.component';

const routes: Routes = [
  {
    path: '',
    component: PageLayoutComponent,
    children: [
      // Auth + Public routes
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },

      // Public course routes
      { path: '', component: CoursesListComponent },
      { path: 'course-list', component: CourseListComponent },

      // Authenticated routes
      {
        path: 'home',
        component: HomeComponent,
        children: [
          {
            path: 'instructor',
            loadChildren: () =>
              import('./components/instructor/instructor.module').then(
                (m) => m.InstructorModule
              ),
            canMatch: [authGuard],
            data: { roles: 'instructor' },
          },
          {
            path: 'student',
            loadChildren: () =>
              import('./components/student/student.module').then(
                (m) => m.StudentModule
              ),
            canMatch: [authGuard],
            data: { roles: 'student' },
          },
          {
            path: 'admin',
            loadChildren: () =>
              import('./components/admin/admin.module').then(
                (m) => m.AdminModule
              ),
            canMatch: [authGuard],
            data: { roles: 'admin' },
          },
          {
            path: 'enrollment',
            loadChildren: () =>
              import('./components/enrollment/enrollment.module').then(
                (m) => m.EnrollmentModule
              ),
            canMatch: [authGuard],
            data: { roles: ['student', 'admin'] },
          },
        ],
      },

      {
        path: 'course',
        loadChildren: () =>
          import('./components/course/course.module').then(
            (m) => m.CourseModule
          ),
        data: { roles: ['student', 'admin', 'instructor'] },
      },
    ],
  },

  // 404 fallback
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
